import axios from 'axios';

export const deleteBearerToken = () => {
    axios.defaults.headers.common = {};
};
